import React, { useState } from 'react';

const InputOutputMachine = () => {
  const inputs = [
    { emoji: '✋', output: 'Hello!' },
    { emoji: '👋', output: 'Goodbye!' },
    { emoji: '😊', output: 'Smile!' },
    { emoji: '😢', output: 'Sad face!' },
    { emoji: '😡', output: 'Angry face!' },
    { emoji: '🎈', output: 'Balloon!' },
    { emoji: '🎂', output: 'Happy birthday!' },
    { emoji: '👏', output: 'Great job!' },
    { emoji: '👍', output: 'Thumbs up!' },
    { emoji: '👎', output: 'Thumbs down!' },
    { emoji: '👋', output: 'Waving Hello!' },
    { emoji: '🤝', output: 'Handshake!' },
    { emoji: '🫢', output: 'Peace!' },
    { emoji: '🚀', output: 'Lift off!' },
    { emoji: '💪', output: 'Strong!' },
    { emoji: '🧠', output: 'Smart idea!' },
    { emoji: '🎉', output: 'Celebrate!' },
    { emoji: '👁️', output: 'I see!' },
    { emoji: '👂', output: 'I hear you!' }
  ];

  const [index, setIndex] = useState(0);
  const [output, setOutput] = useState('Ready to start? Click the input below!');
  const [showTraining, setShowTraining] = useState(false);
  const [showSimulation, setShowSimulation] = useState(false);
  const [trainingComplete, setTrainingComplete] = useState(false);

  const showOutput = () => {
    setShowTraining(true);
    setShowSimulation(true);
    setTimeout(() => {
      setShowTraining(false);
      setShowSimulation(false);
      setOutput(`🧠 Robot says: "${inputs[index].output}"`);
    }, 2000);
  };

  const nextInput = () => {
    const nextIndex = index + 1;
    if (nextIndex < inputs.length) {
      setIndex(nextIndex);
      setOutput('Click the input below!');
    } else {
      setTrainingComplete(true);
    }
  };

  const styles = {
    container: {
      fontFamily: 'Comic Sans MS',
      background: 'linear-gradient(to right, #FFF8E1, #E1F5FE)',
      padding: '30px',
      textAlign: 'center',
      minHeight: '100vh'
    },
    title: {
      fontSize: '2.6rem',
      color: '#1A237E',
      marginBottom: '10px',
      textShadow: '2px 2px #BBDEFB'
    },
    box: {
      background: '#fff3e0',
      padding: '40px',
      borderRadius: '20px',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
      maxWidth: '720px',
      margin: 'auto',
    },
    outputBox: {
      fontSize: '1.4rem',
      fontWeight: 'bold',
      padding: '20px',
      background: '#E0F2F1',
      borderRadius: '12px',
      minHeight: '60px',
      marginBottom: '20px',
      color: '#00796B',
    },
    emojiButton: {
      fontSize: '3rem',
      background: '#FFF59D',
      padding: '20px 30px',
      borderRadius: '16px',
      border: 'none',
      cursor: 'pointer',
      transition: 'transform 0.3s, background 0.3s',
      marginBottom: '20px'
    },
    training: {
      fontStyle: 'italic',
      color: '#757575',
      margin: '15px 0'
    },
    nextButton: {
      fontSize: '1rem',
      padding: '10px 24px',
      backgroundColor: '#81C784',
      border: 'none',
      borderRadius: '10px',
      color: 'white',
      cursor: 'pointer'
    },
    mapGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '15px',
      justifyContent: 'center',
      marginTop: '20px'
    },
    mapItem: {
      background: '#FCE4EC',
      border: '2px solid #F8BBD0',
      borderRadius: '14px',
      padding: '15px 20px',
      fontSize: '1.1rem',
      minWidth: '120px',
      textAlign: 'center',
      boxShadow: '2px 2px 8px rgba(0,0,0,0.1)'
    },
    simulationGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '10px',
      justifyItems: 'center',
      margin: '20px 0'
    },
    simIcon: {
      fontSize: '2rem',
      background: '#FFF59D',
      padding: '10px',
      borderRadius: '10px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🤖 Activity 1: Input → Output Machine</h1>
      <div style={styles.box}>
        <div style={styles.outputBox}>{output}</div>
        {!trainingComplete && (
          <>
            <button style={styles.emojiButton} onClick={showOutput}>{inputs[index].emoji}</button>
            {showTraining && <div style={styles.training}>🤖 Machine is learning from the input...</div>}
            {showSimulation && (
              <div style={styles.simulationGrid}>
                {Array(15).fill(null).map((_, i) => (
                  <div key={i} style={styles.simIcon}>{inputs[index].emoji}</div>
                ))}
              </div>
            )}
            {!showTraining && output.includes('Robot says') && (
              <button style={styles.nextButton} onClick={nextInput}>Next Input ➔</button>
            )}
          </>
        )}
        {trainingComplete && (
          <>
            <div style={styles.outputBox}>🎉 Training complete! Here's what the machine learned:</div>
            <div style={styles.mapGrid}>
              {inputs.map((item, idx) => (
                <div key={idx} style={styles.mapItem}>{item.emoji} → {item.output}</div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InputOutputMachine;
